/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HangYeChaXunTiaoJian,
  HangYeChuangJianGengXinXinXi,
  ResponseApiHangYeXiangQing,
  ResponseApiIPageHangYeLieBiao,
  ResponseApiListHangYeLieBiao,
  ResponseApiLong,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class HangYeGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name GetChildIndustriesUsingPost
   * @summary 根据父级ID获取子行业列表
   * @request POST:/dsp-admin/api/industry/children/{parentCode}
   * @secure
   */
  getChildIndustriesUsingPost = (
    parentCode?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListHangYeLieBiao, void>({
      path: `/dsp-admin/api/industry/children/${parentCode}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name CreateIndustryUsingPost
   * @summary 创建行业
   * @request POST:/dsp-admin/api/industry/create
   * @secure
   */
  createIndustryUsingPost = (
    createDTO: HangYeChuangJianGengXinXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/industry/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name GetFirstLevelIndustriesUsingPost
   * @summary 获取一级行业列表
   * @request POST:/dsp-admin/api/industry/first-level
   * @secure
   */
  getFirstLevelIndustriesUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiListHangYeLieBiao, void>({
      path: `/dsp-admin/api/industry/first-level`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name IndustryListUsingPost
   * @summary 分页查询行业列表
   * @request POST:/dsp-admin/api/industry/list
   * @secure
   */
  industryListUsingPost = (
    查询条件参数: HangYeChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageHangYeLieBiao, void>({
      path: `/dsp-admin/api/industry/list`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name GetIndustryTreeUsingPost
   * @summary 获取树形结构的行业列表
   * @request POST:/dsp-admin/api/industry/tree
   * @secure
   */
  getIndustryTreeUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiListHangYeLieBiao, void>({
      path: `/dsp-admin/api/industry/tree`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name GetIndustryUsingPost
   * @summary 获取行业详情
   * @request POST:/dsp-admin/api/industry/{id}
   * @secure
   */
  getIndustryUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiHangYeXiangQing, void>({
      path: `/dsp-admin/api/industry/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name UpdateIndustryUsingPut
   * @summary 更新行业
   * @request PUT:/dsp-admin/api/industry/{id}
   * @secure
   */
  updateIndustryUsingPut = (
    createDTO: HangYeChuangJianGengXinXinXi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/industry/${id}`,
      method: "PUT",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HangYeGuanLi
   * @name DeleteIndustryUsingDelete
   * @summary 删除行业
   * @request DELETE:/dsp-admin/api/industry/{id}
   * @secure
   */
  deleteIndustryUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/industry/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new HangYeGuanLi();
